var PageDataFields = /** @class */ (function () {
    function PageDataFields(pageDataContext) {
        this.pageDataContext = {
            title: pageDataContext.title,
            pageId: pageDataContext.pageId,
            pageName: pageDataContext.pageName,
            baseUrl: pageDataContext.baseUrl,
            appName: pageDataContext.appName,
        };
    }
    return PageDataFields;
}());
export { PageDataFields };
//# sourceMappingURL=page-data-fields.js.map